import React, { useState, useRef, useEffect } from "react";
import { FaBars, FaTimes } from "react-icons/fa";
import { NavLink } from "react-router-dom"; // Import NavLink from react-router-dom
import NavbarLogo from "../assets/images/navbar-logo.png";
import {
  TextField,
  InputAdornment,
  MenuItem,
  ListItemText,
  Popper,
  Paper,
} from "@mui/material";
import { Search as SearchIcon } from "@mui/icons-material";
const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth <= 768);
  const menuRef = useRef(null);

  useEffect(() => {
    const handleResize = () => {
      setIsSmallScreen(window.innerWidth <= 941);
      if (window.innerWidth > 941) {
        setIsMenuOpen(false);
      }
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleMenuToggle = () => {
    setIsMenuOpen((prev) => !prev);
  };

  const handleCloseMenu = () => {
    setIsMenuOpen(false);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        handleCloseMenu();
      }
    };

    const handleEscapeKey = (event) => {
      if (event.key === "Escape") {
        handleCloseMenu();
      }
    };

    // Add event listeners
    document.addEventListener("mousedown", handleClickOutside);
    document.addEventListener("keydown", handleEscapeKey);

    // Clean up event listeners on component unmount
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      document.removeEventListener("keydown", handleEscapeKey);
    };
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };
  const [hoveredIndex, setHoveredIndex] = useState(null);

  const handleMouseEnter = (index) => setHoveredIndex(index);
  const handleMouseLeave = () => setHoveredIndex(null);
  const linkStyles = (isActive, index) => ({
    ...styles.link,
    color: hoveredIndex === index ? "orange" : styles.link.color,
    ...(isActive
      ? {
          ...styles.activeLink,
        }
      : {}),
  });
  const options = [
    { label: "Home", path: "/" },
    { label: "About Swamiji", path: "/about-swamiji" },
    // { label: "Vedanta Classes", path: "/vedanta-classes" },
    { label: "Discourses", path: "/discourses" },
    { label: "Contact Us", path: "/contact-us" },
    { label: "Privacy Policy", path: "/privacy-policy" },
    { label: "Help & Support", path: "/help-support" },
  ];

  const searchOptions = [
    { label: "Home", path: "/" },
    { label: "About Swamiji", path: "/about-swamiji" },
    // { label: "Vedanta Classes", path: "/vedanta-classes" },
    { label: "Discourses", path: "/discourses" },
    { label: "Contact Us", path: "/contact-us" },
    { label: "Privacy Policy", path: "/privacy-policy" },
    { label: "Help & Support", path: "/help-support" },
  ];

  const [searchTerm, setSearchTerm] = useState("");
  const [anchorEl, setAnchorEl] = useState(null);

  const filteredOptions = options.filter((option) =>
    option.label.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const [query, setQuery] = useState("");
  const [anchorElement, setAnchorElement] = useState(null);
  const [open, setOpen] = useState(false);
  const filteredSearchOptions = searchOptions.filter((option) =>
    option.label.toLowerCase().includes(query.toLowerCase())
  );

  const handleOptionClick = (path) => {
    window.location.href = path; // Navigate using window.location
    setSearchTerm(""); // Clear the search term
    setAnchorEl(null); // Close the dropdown
  };

  const handleOptionClick1 = (path) => {
    console.log("Option clicked: ", path); // Debugging log to confirm click
    window.location.href = path; // Navigate using window.location
    setQuery(""); // Clear the search term
    setAnchorElement(null); // Close the dropdown
    setOpen(false); // Close dropdown
  };

  return (
    <>
      {/* <div>
        {isSmallScreen && (
          <>
            <FaBars style={styles.menuIcon} onClick={handleMenuToggle} />
            <img src={NavbarLogo} alt="Logo" style={styles.logo} />
          </>
        )}
      </div> */}
      <div style={styles.navbar}>
        <div
          style={
            isSmallScreen
              ? styles.headerContainerSmallScreen
              : styles.headerContainer
          }
        >
          {isSmallScreen && (
            <div style={styles.headerContainer}>
              <a href="/">
                <img src={NavbarLogo} alt="Logo" style={styles.logo} />
              </a>
              <FaBars
                style={{
                  ...styles.smallerScreenMenuIcon,
                  marginLeft: "auto",
                }}
                onClick={handleMenuToggle}
              />
            </div>
          )}
          {!isSmallScreen && (
            <a href="/">
              <img src={NavbarLogo} alt="Logo" style={styles.logo} />
            </a>
          )}
          {!isSmallScreen && (
            <div style={styles.linksContainer}>
              {["Home", "About Swamiji", "Discourses"].map(
                (text, index) => {
                  const path = `/${text.replace(/\s+/g, "-").toLowerCase()}`;

                  return (
                    <NavLink
                      key={index}
                      to={path}
                      style={({ isActive }) => {
                        // Treat '/' and '/home' as the same for isActive
                        const active =
                          isActive ||
                          (path === "/home" &&
                            window.location.pathname === "/");
                        return linkStyles(active, index);
                      }}
                      onMouseEnter={() => handleMouseEnter(index)}
                      onMouseLeave={handleMouseLeave}
                      onClick={scrollToTop}
                    >
                      {({ isActive }) => {
                        const active =
                          isActive ||
                          (path === "/home" &&
                            window.location.pathname === "/");
                        return (
                          <>
                            {text}
                            {active && <span style={styles.underline} />}{" "}
                            {/* Underline only for active link */}
                          </>
                        );
                      }}
                    </NavLink>
                  );
                }
              )}
              {!isSmallScreen && (
                <div style={{ position: "relative" }}>
                  {" "}
                  {/* Ensure proper relative positioning */}
                  <TextField
                    variant="outlined"
                    placeholder="Search..."
                    sx={{
                      "& .MuiOutlinedInput-root": {
                        borderRadius: "25px",
                        height: "40px",
                        fontSize: "16px",
                        padding: "0 10px",
                        display: "flex",
                        alignItems: "center",
                      },
                      width: "200px",
                      marginLeft: "20px",
                    }}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <SearchIcon />
                        </InputAdornment>
                      ),
                    }}
                    value={searchTerm}
                    onChange={(e) => {
                      setSearchTerm(e.target.value);
                      setAnchorEl(e.currentTarget); // Open dropdown when typing
                    }}
                  />
                  {/* Dropdown for filtered options */}
                  {searchTerm && anchorEl && filteredOptions.length > 0 && (
                    <Popper
                      open={Boolean(anchorEl)}
                      anchorEl={anchorEl}
                      placement="bottom-start"
                      style={{ zIndex: 9999 }} // Ensure the list is on top of navbar
                    >
                      <Paper style={{ width: anchorEl.offsetWidth }}>
                        {" "}
                        {/* Match width of TextField */}
                        {filteredOptions.map((option) => (
                          <MenuItem
                            key={option.label}
                            onClick={() => handleOptionClick(option.path)}
                          >
                            <ListItemText primary={option.label} />
                          </MenuItem>
                        ))}
                      </Paper>
                    </Popper>
                  )}
                </div>
              )}
            </div>
          )}

          {/* Inject the keyframes in a style tag */}
          <style>{fadeIn}</style>

          {isMenuOpen && (
            <div
              ref={menuRef}
              style={{
                ...smallerScreenStyles.linksContainer,
                ...(isMenuOpen ? smallerScreenStyles.menuOpen : {}),
              }}
            >
              {/* Close Icon */}
              <FaTimes
                style={smallerScreenStyles.closeIcon}
                onClick={handleCloseMenu}
              />
              {/* Search Box */}
              <div style={{ position: "relative" }}>
                <TextField
                  variant="outlined"
                  placeholder="Search..."
                  sx={{
                    width: "90%",
                    margin: "20px",
                    "& .MuiOutlinedInput-root": {
                      borderRadius: "25px",
                      height: "40px",
                      "& fieldset": {
                        borderColor: "orange", // Border color
                      },
                      "&:hover fieldset": {
                        borderColor: "darkorange", // Border color on hover
                      },
                      "&.Mui-focused fieldset": {
                        borderColor: "white", // Border color when focused
                      },
                    },
                    "& .MuiInputBase-input": {
                      color: "white", // Text color
                    },
                    "& .MuiInputBase-input::placeholder": {
                      color: "orange", // Placeholder text color
                    },
                    "& .MuiSvgIcon-root": {
                      color: "orange", // Icon color
                    },
                  }}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <SearchIcon />
                      </InputAdornment>
                    ),
                  }}
                  value={query}
                  onChange={(e) => {
                    setQuery(e.target.value);
                    setAnchorElement(e.currentTarget);
                    setOpen(true); // Open dropdown when typing
                  }}
                  onBlur={() => {
                    setOpen(false); // Close dropdown when losing focus
                  }}
                />

                {/* Dropdown for filtered options */}
                {open &&
                  query &&
                  anchorElement &&
                  filteredSearchOptions.length > 0 && (
                    <Popper
                      open={open} // Control with open state
                      anchorEl={anchorElement}
                      placement="bottom-start"
                      style={{ zIndex: 9999 }} // Ensure the list is on top of navbar
                    >
                      <Paper style={{ width: anchorElement.offsetWidth }}>
                        {filteredSearchOptions.map((option) => (
                          <MenuItem
                            key={option.label}
                            onMouseDown={() => handleOptionClick(option.path)}
                          >
                            <ListItemText primary={option.label} />
                          </MenuItem>
                        ))}
                      </Paper>
                    </Popper>
                  )}
              </div>
              {/* Links */}
              {["Home", "About Swamiji", "Discourses"].map(
                (text, index) => {
                  const path = `/${text.replace(/\s+/g, "-").toLowerCase()}`;
                  return (
                    <NavLink
                      key={index}
                      to={path}
                      style={({ isActive }) => {
                        // Treat '/' and '/home' as the same for isActive
                        const active =
                          isActive ||
                          (path === "/home" &&
                            window.location.pathname === "/");
                        return {
                          ...smallerScreenStyles.link,
                          ...(active
                            ? {
                                fontWeight: "bold",
                                ...smallerScreenStyles.activeLink,
                              }
                            : {}),
                        };
                      }}
                      onClick={() => {
                        scrollToTop();
                        handleCloseMenu();
                      }}
                    >
                      {text}
                      <span style={smallerScreenStyles.underline}></span>
                    </NavLink>
                  );
                }
              )}
            </div>
          )}
        </div>
      </div>
    </>
  );
};

const styles = {
  navbar: {
    position: "sticky",
    top: 0,
    width: "100%",
    backgroundColor: "#fff",
    // boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
    paddingBottom: "10px",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    zIndex: 1000,
  },
  headerContainer: {
    display: "flex",
    width: "95%",
    justifyContent: "space-between",
    alignItems: "center",
  },
  headerContainerSmallScreen: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    width: "100%",
  },
  logo: {
    height: "80px",
    marginRight: "20px",
  },
  smallScreenLogo: {
    height: "80px",
    marginRight: "auto",
    marginLeft: "auto",
    display: "block",
  },
  menuIcon: {
    fontSize: "24px",
    cursor: "pointer",
    marginTop: "30px",
    marginLeft: "30px",
    color: "#333",
  },
  smallerScreenMenuIcon: {
    fontSize: "24px",
    cursor: "pointer",
    color: "#333",
  },
  linksContainer: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-end",
    width: "110%",
    padding: "0 20px",
    marginTop: "10px",
  },
  link: {
    display: "flex", // Ensure the link content is vertically centered
    alignItems: "center", // Center align the link text
    textDecoration: "none",
    color: "#333",
    margin: "0 15px",
    fontSize: "16px",
    fontWeight: "500",
    position: "relative",
    transition: "color 0.3s ease",
    overflow: "hidden",
    paddingBottom: "5px", // Ensure space for the underline
  },
  linkHover: {
    "&:hover .underline": {
      transform: "scaleX(1)", // Show underline on hover
    },
  },
  activeLink: {
    color: "orange", // Color for the text of the active link
    position: "relative", // Required for the ::after pseudo-element positioning
    paddingBottom: "5px", // Space for the underline to appear
    fontWeight: "bold", // Example text styling for the active link
  },
  underline: {
    position: "absolute",
    bottom: 0,
    left: 0,
    height: "2px",
    width: "100%",
    backgroundColor: "orange",
    transform: "scaleX(1)", // Underline scale
    transformOrigin: "bottom left",
    transition: "transform 0.3s ease", // Smooth transition for underline
    zIndex: 9999,
  },
  "active-link": {
    color: "orange",
  },
};

const smallerScreenStyles = {
  navbar: {
    position: "relative",
    width: "100%",
    padding: "10px 20px",
    backgroundColor: "#fff",
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
  },
  menuIcon: {
    fontSize: "30px",
    cursor: "pointer",
    color: "#333",
  },
  linksContainer: {
    position: "fixed", // Fixed positioning for the sliding effect
    top: 0,
    right: 0,
    height: "100vh", // Full screen height
    width: "250px",
    backgroundColor: "#8C3A00",
    display: "flex",
    flexDirection: "column",
    alignItems: "center", // Center align items
    paddingTop: "20px", // Add padding to the top
    transform: "translateY(-100%)", // Hidden initially
    transition: "transform 0.5s ease-in-out", // Smooth sliding effect
  },
  menuOpen: {
    transform: "translateY(0)", // Show menu
  },
  closeIcon: {
    fontSize: "30px",
    color: "orange",
    alignSelf: "flex-end",
    margin: "10px",
    cursor: "pointer",
  },
  link: {
    textDecoration: "none",
    color: "orange",
    fontSize: "18px",
    margin: "10px 0",
    width: "100%", // Full width for links
    textAlign: "center", // Center align text
    opacity: 0,
    animation: "fadeIn 0.5s forwards",
    animationDelay: "0.2s",
  },
  activeLink: {
    color: "#fff",
    position: "relative",
    // backgroundColor: "orange",
    transform: "scaleX(1)",
    transition: "transform 0.3s ease",
    zIndex: 9999,
    left: "50%", // Center the underline
    transform: "translateX(-50%) scaleX(1)", // Center the underline
    width: "100%", // Ensure full width for underline
  },
  underline: {
    position: "absolute",
    bottom: 0,
    left: "50%",
    width: "100%",
    height: "2px",
    backgroundColor: "#fff",
    transform: "translateX(-50%) scaleX(50%)",
    transition: "transform 0.3s ease",
  },
};
// Keyframes for link fade-in animation
const fadeIn = `@keyframes fadeIn {
  0% { opacity: 0; }
  100% { opacity: 1; }
}`;
export default Navbar;
